import { cn } from "@/lib/utils";

type ThemeBrandmarkProps = {
  className?: string;
  decorative?: boolean;
  imageClassName?: string;
  variant?: "wordmark" | "icon";
};

export function ThemeBrandmark({
  className,
  decorative = false,
  imageClassName,
  variant = "wordmark",
}: ThemeBrandmarkProps) {
  if (variant === "icon") {
    return (
      <div className={cn("theme-brandmark", className)}>
        <img
          alt={decorative ? "" : "Atmina"}
          aria-hidden={decorative ? "true" : undefined}
          className={cn(
            "theme-brandmark__image theme-brandmark__image--icon",
            imageClassName,
          )}
          src="/favicon.svg"
        />
      </div>
    );
  }

  return (
    <div className={cn("theme-brandmark", className)}>
      <img
        alt={decorative ? "" : "Atmina"}
        aria-hidden={decorative ? "true" : undefined}
        className={cn(
          "theme-brandmark__image theme-brandmark__image--light",
          imageClassName,
        )}
        src="/atmina-wordmark-black.png"
      />
      <img
        alt=""
        aria-hidden="true"
        className={cn(
          "theme-brandmark__image theme-brandmark__image--dark",
          imageClassName,
        )}
        src="/atmina-wordmark-white.png"
      />
      <img
        alt=""
        aria-hidden="true"
        className={cn(
          "theme-brandmark__image theme-brandmark__image--yellow",
          imageClassName,
        )}
        src="/atmina-wordmark-yellow.png"
      />
    </div>
  );
}
